import { render } from "./AppHomeManage.vue?vue&type=template&id=f6b6b4ca"
import script from "./AppHomeManage.vue?vue&type=script&lang=js"
export * from "./AppHomeManage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__